/*
 * Copyright (c) 2024 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 30/4/2024
 */

import jwtEncode from 'jwt-encode';

export const generateOpenApiKey = (orgId = +process.env.REACT_APP_ORGID) => {
    const d = new Date();
    const secret = process.env.REACT_APP_OPEN_API_SECRET_ONE + process.env.REACT_APP_OPEN_API_SECRET_TWO + process.env.REACT_APP_OPEN_API_SECRET_THREE ;

    const dataToEncrypt = {
        key: process.env.REACT_APP_OPEN_API_KEY,
        orgId
    };

    // Encode payload as JWT token
    const token = jwtEncode(dataToEncrypt, secret, { expiresIn: 60 * 30 });

    return token;
}